import React, { Component } from 'react';
import _ from 'lodash';
import { getCaches } from '../Api';

import storage from '../store/storage';

const fetchIfCacheIsExpiredOtherwiseJustLoad = ({
  getUpdateCache,
  load,
  fetch,
  current,
  onFetched,
}) => {
  getCaches()
    .then(({ data }) => {
      const cacheIsNotExpired = !!current && current === getUpdateCache(data);
      if (cacheIsNotExpired) {
        load();
      } else {
        onFetched();
        fetch();
      }
    })
    .catch(() => load());
};

const loadingFromDbAndSaving = ({ db, save }) => {
  db.load((value) => {
    if (!value) {
      return;
    }
    save(value);
  });
};

const fetchingFromDb = ({
  onFetched, load, onPersist, db,
}) => {
  const onFetchCompleted = () => {
    load();
    getCaches().then(({ data }) => onPersist(data));
    if (_.isFunction(onFetched)) {
      onFetched();
    }
  };
  return db.fetchAndSave(onFetchCompleted);
};

export const fetchFromJson = ({
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
  willFetch,
  WrappedComponent,
  createIndexOnFetch = () => {},
}) => class FetchFromJson extends Component {
    state = {
      value: {},
      updateCache: storage.load({
        key: updateCache,
      }),
      index: {},
    };

    load = () => {
      loadingFromDbAndSaving({
        current: this.state.updateCache,
        db,
        save: (value) => {
          const index = createIndexOnFetch(value);
          this.setState({ index: index || {} });
          this.setState({ value });
        },
      });
    };

    fetchIfCacheIsExpiredOtherwiseJustLoad = () => {
      fetchIfCacheIsExpiredOtherwiseJustLoad({
        getUpdateCache,
        load: this.load,
        fetch: () => this.fetch(),
        current: this.state.updateCache,
        onFetched: () => this.props.toast.setToast({ title: toast }),
      });
    };

    persistUpdateCache = (value) => {
      storage.save({
        key: updateCache,
        value,
      });
    };

    fetch = (onFetched = () => {}) => {
      if (willFetch) {
        willFetch();
      }
      return fetchingFromDb({
        onFetched,
        load: this.load,
        db,
        onPersist: (data) => this.persistUpdateCache(getUpdateCache(data)),
      });
    };

    render() {
      const props = {
        [entityName]: {
          value: this.state.value,
          fetchIfCacheIsExpiredOtherwiseJustLoad: this
            .fetchIfCacheIsExpiredOtherwiseJustLoad,
          fetch: this.fetch,
          load: this.load,
          index: this.state.index,
        },
      };
      return <WrappedComponent {...this.props} {...props} />;
    }
};
